import React, { useState, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { usePackages } from '../../../contexts/PackagesContext';
import Input from '../../../components/ui/Input';

export default function Step4({ control, errors }) {
  const { selectedPeriods, setSelectedPeriods, periodPrices, setPeriodPrices } = usePackages();
  const [basePrice, setBasePrice] = useState(periodPrices.one_month || 0);

  const applyDiscount = (percentage, periodName) => {
    const found = selectedPeriods.find(p => p.name === periodName);
    if (!found) return;
    const discounted = ((basePrice * found.period) - (basePrice * found.period * (percentage / 100))).toFixed(2);
    setPeriodPrices(prev => ({ ...prev, [periodName]: parseFloat(discounted) }));
    setSelectedPeriods(prev => prev.map(p => p.name === periodName ? { ...p, percentage, price: parseFloat(discounted) } : p));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Recalculate all discounts when base price changes
    selectedPeriods.forEach(p => {
      const discounted = ((basePrice * p.period) - (basePrice * p.period * (p.percentage / 100))).toFixed(2);
      setPeriodPrices(prev => ({ ...prev, [p.name]: parseFloat(discounted) }));
      setSelectedPeriods(prev => prev.map(sp => sp.name === p.name ? { ...sp, price: parseFloat(discounted) } : sp));
    });
  }, [basePrice]);

  return (
    <div className="space-y-5 max-w-sm mx-auto">
      <Controller name="price" control={control}
        rules={{ required: 'Base price is required' }}
        render={({ field }) => (
          <Input
            label="Base Monthly Price (USD)"
            type="number"
            prefix="$"
            {...field}
            onChange={e => {
              const val = e.target.value ? Number(e.target.value) : 0;
              field.onChange(val);
              setBasePrice(val);
            }}
            error={errors.price?.message}
          />
        )} />

      <div className="space-y-4 pt-2 border-t border-white/[0.08]">
        <p className="text-xs text-text-muted font-medium uppercase tracking-wider">Period Discounts</p>
        {[
          { name: 'six_months', label: '6 Months', field: 'six_months_price' },
          { name: 'one_year',   label: '1 Year',   field: 'one_year_price' },
        ].map(({ name, label, field: fieldName }) => {
          const period = selectedPeriods.find(p => p.name === name);
          return (
            <div key={name}>
              <Controller name={fieldName} control={control}
                rules={{ required: 'Required' }}
                render={({ field }) => (
                  <div>
                    <label className="label">{label} Discount %</label>
                    <div className="flex items-center gap-3">
                      <div className="flex-1">
                        <Input
                          type="number"
                          suffix="%"
                          {...field}
                          onChange={e => { field.onChange(Number(e.target.value)); applyDiscount(Number(e.target.value), name); }}
                          error={errors[fieldName]?.message}
                        />
                      </div>
                      <div className="text-right">
                        <p className="text-xs text-text-muted">Total price</p>
                        <p className="text-sm font-bold text-teal">${periodPrices[name] ?? 0}</p>
                      </div>
                    </div>
                  </div>
                )} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
